var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main hcd_main" },
            [
              _c("SubTitleComponent", {
                attrs: { title: _vm.title, type: "" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "el-descriptions",
                    {
                      attrs: { title: "", direction: "", column: 1, border: "" }
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "行业类型" } },
                        [_vm._v(_vm._s(_vm.customerData.type))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "项目类型" } },
                        [_vm._v(_vm._s(_vm.customerData.project))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "项目地址" } },
                        [_vm._v(_vm._s(_vm.customerData.address))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "项目面积" } },
                        [_vm._v(_vm._s(_vm.customerData.square) + "平方米")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "风格偏好" } },
                        [_vm._v(_vm._s(_vm.customerData.style))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "设计理念" } },
                        [_vm._v(_vm._s(_vm.customerData.design))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label:
                              "项目图(" + _vm.customerEffect.length + "张)",
                            labelStyle: "width: 80px;"
                          }
                        },
                        [
                          _vm.customerEffect.length > 0
                            ? _c(
                                "div",
                                { staticClass: "renderBox" },
                                _vm._l(_vm.customerEffect, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "item",
                                      on: {
                                        click: function($event) {
                                          return _vm.toDetail(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            item.photo_url +
                                            "?x-oss-process=image/resize,m_fill,w_300,h_300",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "name" }, [
                                        _vm._v(_vm._s(item.title))
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.dialogVisible == "detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        top: "15vh",
                        "show-close": false,
                        center: true,
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _vm.dialogCur != -1
                        ? _c("div", { staticClass: "img" }, [
                            _c("img", {
                              attrs: {
                                src:
                                  _vm.customerEffect[_vm.dialogCur].photo_url,
                                alt: ""
                              }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d3588f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3588f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomerHistory/Detail.vue
// module id = null
// module chunks = 